<template>
	<el-table-column width="140" sortable="custom" prop="orders" label="排序">
	  <template slot-scope="scope">
	 <el-input type="number" size="mini" v-model="scope.row.orders">
	  <el-button slot="append" icon="el-icon-check"  size="mini"   type="primary" @click="ordersClick(scope.row)"></el-button></el-input>
	  </template>
	</el-table-column>
</template>

<script>
	export default {
			      
	  data() {
	    return {
			pageName:''
				 }
	  },
			
	  methods: {
				ordersClick(e){
				 this.$axios.post(`/api/${this.pageName}/Post${this.pageName}Orders`,{id:e.id,orders:e.orders}).then(e => {
				 	 this.$message.success('操作成功到同步服务器');
				   });
				},
			},
			mounted() {
			this.pageName= this.$route.path.replace('/','')
			},
	}
</script>

<style>
</style>
